import React, { Component } from 'react'
import TopSellers from './Categories/TopSellers'
import BestOffer from './Categories/BestOffer'
import styles from './HomePage.module.css'
import { Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import Slideshow from './Slideshow'
import SlideshowD from './Categories/SlideshowD'
import firebase from '../../app/config/firebase.js'

class HomePage extends Component {
  componentDidMount() {
    const messaging = firebase.messaging();
    const sendTokenToServer = firebase
      .app()
      .functions('asia-south1')
      .httpsCallable('pushmessagingtoken');
    Notification
      .requestPermission()
      .then(() => {
        return messaging.getToken()
      })
      .then((token) => {
        return sendTokenToServer({token})
      })
      .then((token) => {
        return console.log(token)
      })
      .catch(() => console.log('error'))
  }
  render() {
    return (
      <div>
        <div className={styles.bannerm}>
          <Slideshow />
        </div>
        <div className={styles.bannerd}>
          <SlideshowD />
        </div>
        <div className={styles.savings}>
          <div className={styles.innersavings}>
            <h4>Natural is Beautiful</h4>
            <p>We truly believe that using natural, eco-friendly products is the safest and most effective way to look and feel your best. Increasing studies link chemicals in traditional cosmetics, skincare, and other personal care products to health conditions such as allergies, hormonal disruptions, reproductive issues, cancer, and many others. The only cosmetic ingredients regulated by the FDA are color additives meaning almost anything can go into cosmetics. This makes it very hard for consumers to know which products are potentially harmful.</p>
          </div>
        </div>
        <div className={styles.himher}>
          <div className={styles.her}>
            <div
              className={[
                styles.animated,
                styles.animatedFadeInUp,
                styles.fadeInUp,
              ].join(' ')}
            >
              <h2>MakeUp Essentials</h2>
              <p>
                Everything you need<br />
                for glowing skin
              </p>
              <Link to='/her'>
                <Button  fluid style={{ textTransform: 'uppercase' }}>
                  Shop Now
                </Button>
              </Link>
            </div>
          </div>
          <div className={styles.him}>
            <div
              className={[
                styles.animated,
                styles.animatedFadeInUp,
                styles.fadeInUp,
              ].join(' ')}
            >
              <h2>Gorgeous Tresses</h2>
              <p>
                Beautiful healthy hair <br />
                can be yours
              </p>
              <Link to='/him'>
                <Button fluid style={{ textTransform: 'uppercase' }}>
                  Shop Now
                </Button>
              </Link>
            </div>
          </div>
        </div>
        <div className={styles.shopby}>
          <div className={styles.innershopby}>
            <h3>Shop By</h3>
            <div className={styles.categories}>
              <div className={styles.item1}>
                <span>
                  <Link to='/tops'>Bath + Body</Link>
                </span>
              </div>
              <div className={styles.item2}>
                <span>
                  <Link to='/tunics'>Nails</Link>
                </span>
              </div>
              <div className={styles.item3}>
                <span>
                  <Link to='/dress'>Eyes + Brows</Link>
                </span>
              </div>
              <div className={styles.item4}>
                <span>
                  <Link to='/sweatshirts'>Skin Care</Link>
                </span>
              </div>
            </div>
          </div>
        </div>
        <TopSellers />
        <BestOffer />
      </div>
    )
  }
}

export default HomePage
